import { render, staticRenderFns } from "./AntifraudeEstatisticasPessoaComDetalhes.vue?vue&type=template&id=4391fe58&"
import script from "./AntifraudeEstatisticasPessoaComDetalhes.vue?vue&type=script&lang=js&"
export * from "./AntifraudeEstatisticasPessoaComDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports